import { ZERO } from 'constants/number'
import { Token2BNumber } from 'interfaces/index.interface'
import { makeAutoObservable } from 'mobx'

class AccountStore {
  private connectedAddress: string
  private tokensInWallet: string[] // for store current watching token in wallet
  balance: Token2BNumber
  eligible: boolean
  loadEligible: boolean

  constructor() {
    this.connectedAddress = ''
    this.balance = {}
    this.tokensInWallet = []
    this.eligible = false
    this.eligible = false
    makeAutoObservable(this)
  }

  getBalanceOf = (address?: string) => {
    if (!address) return ZERO
    return this.balance[address] ?? ZERO
  }

  setAddress = (address: string) => {
    this.connectedAddress = address.toLowerCase()
    if (address === '') this.eligible = false
  }

  setEligible = (e: boolean, l: boolean) => {
    this.eligible = e
    this.loadEligible = l
  }

  setTokenInWallet = (tokens: string[]) => {
    this.tokensInWallet = tokens
  }

  updateBalance = (balance: Token2BNumber) => {
    this.balance = { ...this.balance, ...balance }
  }

  get isActive() {
    return this.connectedAddress !== ''
  }

  get address() {
    return this.connectedAddress
  }

  get walletBalance() {
    return this.balance
  }

  get tokens() {
    return this.tokensInWallet
  }
}

export const accountStore = new AccountStore()
